'use client';

import { SvgAdd, SvgMinus, SvgTrash } from '@common/icon';
import { cn } from '@core/utils';

export interface CartCountProps {
  count: number;
  min?: number;
  onCountChange?: (count: number) => void;
  onDelete?: () => void;
  className?: string;
}

export const CartCount = ({
  count,
  min = 1,
  onCountChange,
  onDelete,
  className,
}: CartCountProps) => {
  const isMinReached = count <= min;
  const showDeleteButton = isMinReached && onDelete;

  return (
    <div
      className={cn(
        'flex h-36 w-90 items-center justify-center gap-8 overflow-hidden rounded-xsmall border border-Gray-400 bg-Gray-white px-12 mobile-tablet:h-26 mobile-tablet:w-auto mobile-tablet:gap-4 mobile-tablet:px-8',
        className,
      )}
    >
      {showDeleteButton ? (
        <button
          type="button"
          onClick={onDelete}
          aria-label="삭제"
          className="size-12 text-Gray-600"
        >
          <SvgTrash className="size-12" />
        </button>
      ) : (
        <button
          type="button"
          onClick={() => onCountChange?.(Math.max(min, count - 1))}
          aria-label="수량 감소"
          disabled={isMinReached}
          className={cn('size-12', isMinReached ? 'text-Gray-400' : 'text-Gray-900')}
        >
          <SvgMinus className="size-12" />
        </button>
      )}
      <span className="min-w-20 text-center font-400 text-Gray-black typo-body4 mobile-tablet:typo-caption1">
        {count}
      </span>
      <button
        type="button"
        onClick={() => onCountChange?.(count + 1)}
        aria-label="수량 증가"
        className="size-12 text-Gray-900"
      >
        <SvgAdd className="size-12" />
      </button>
    </div>
  );
};
